import { HashLocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class ParameterPathLocationStrategy extends HashLocationStrategy {
  override prepareExternalUrl(internal: string): string {
    const qp = window.location.search;
    if (internal === '/login/redirect') {
      return internal + qp;
    }
    return '#' + internal;
  }
}
